export const colorsDiagram = {
    regular: '#00c0ff',
    start: '#19c105', // 85d800
    onEvent: '#c000ff',
    looped: '#f34374'
};